import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-modal',
  standalone: true,
  templateUrl: './modal.html',
  styleUrls: ['./modal.scss'],
})
export class Modal {
  public isOpen = input<boolean>(false);
  public title = input<string>('');
  public closable = input<boolean>(true);
  public size = input<'default' | 'large'>('default');
  public close = output<void>();
}
